import axios from "axios"

const duplicateProfile = () => {
  return axios
    .get("/panel/duplicate-profile")
    .then(response => {
      console.log("response from server", response.status, response.data)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const deleteProfile = () => {
  return axios
    .get("/panel/delete-profile")
    .then(response => {
      console.log("response from server", response.status, response.data)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const pausePlan = days => {
  return axios
    .post("/panel/pause-plan", { days: Number(days) })
    .then(response => {
      console.log("response from server", response.status, response.data)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const activateAgencyP = plan => {
  return axios
    .post("/panel/activate-agency-profile", plan)
    .then(response => {
      console.log("response from server", response.status, response.data)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

export default { duplicateProfile, deleteProfile, pausePlan, activateAgencyP }
